import React from 'react';
import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash';
import DetailVisibleProvider from 'context/dash/DetailVisible';
import ShowAllEventsProvider from 'context/dash/ShowAllEvents';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import InstagramAnalysisPage from 'modules/dashboard/producer/instagram/InstagramAnalysisPage';

export default function DashInstagramAnalysis() {
    return (
        <BackButtonCollapseDashProvider>
            <ShowAllEventsProvider>
                <DetailVisibleProvider>

                    <DashContainer title='Análise do Instagram'>
                        <InstagramAnalysisPage />
                    </DashContainer>

                </DetailVisibleProvider>
            </ShowAllEventsProvider>
        </BackButtonCollapseDashProvider>
    );
}
